import React from 'react';
import PropTypes from 'prop-types';
import IssueForm from '../../Issue/IssueForm';

export default function ReportAnIssuePage({ create_issue_endpoint }) {
	return (
		<div className="h-550 w-1/2">
			{/* ... */}
			<IssueForm hideTitle={true} endpoint={create_issue_endpoint} />
		</div>
	);
}

ReportAnIssuePage.propTypes = {
	create_issue_endpoint: PropTypes.string.isRequired
};
